import ButtonSend from '@components/button-send/ButtonSend';
import InputName from '@components/input-name/InputName';
import InputPhone from '@components/input-phone/InputPhone';
import Textarea from '@components/textarea/Textarea';
import { yupResolver } from '@hookform/resolvers/yup';
import { api } from '@lib/api/api';
import ROUTES from '@lib/constants/routes';
import { CAPTCHA_28788, COMMENT_MESSAGE_FORM_FORMA_32007, COOKIE_SECURE_FORMA_29680, RESERVED_FLATS_31832 } from '@lib/flags';
import { favoriteInputFormSelector, formNameSelector, handleOpenModelError, hiddenMessage, mortgageCostSelector, mortgageInitialPaymentSelector, mortgageTermSelector, openTradeInFormSelector } from '@lib/store/slices/ComponentsSlice';
import { flatsLocalStorageSelector } from '@lib/store/slices/FavoriteFlatSlice';
import { policyFormSelector } from '@lib/store/slices/ProjectSlice';
import { CookieStorage } from '@lib/tools/helpers/CookieStorage';
import { UNIVERSAL_ADMIN } from '@lib/tools/helpers/constants';
import { timeOutPromise } from '@lib/tools/helpers/debounceFunction';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import SafeHydrate from '@lib/tools/helpers/SaveHydrate';
import { useViewport } from '@lib/tools/hooks/useViewport';
import { pushDataLayer } from '@lib/tools/pushDataLayer';
import { InvisibleSmartCaptcha } from '@yandex/smart-captcha';
import axios from 'axios';
import cn from 'classnames';
import { usePathname } from 'next/navigation';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import style from './FormCall.module.scss';
function FormCall({
  classNameTitle,
  handleCloseFormModel,
  formNameProp = null,
  testId
}) {
  const [captchaToken, setCaptchaToken] = useState('');
  const [captchaVisible, setCaptchaVisible] = useState(false);
  const [formData, setFormData] = useState(null);
  const [showMessage, setShowMessage] = useState(false);
  const [captchaKey, setCaptchaKey] = useState(crypto.randomUUID());
  const openMessage = () => {
    setShowMessage(true);
  };
  const closeMessage = () => {
    setShowMessage(false);
  };
  const favoriteInputForm = useSelector(favoriteInputFormSelector);
  const openTradeInForm = useSelector(openTradeInFormSelector);
  const dispatch = useDispatch();
  const namePattern = /^[^-\s][а-яА-Яa-zA-Z]/;
  const fullPhonePattern = /^\+7 \([3-9]\d{2}\) \d{3}-\d{2}-\d{2}$/;
  const formName = useSelector(formNameSelector);
  const formPropName = formNameProp ? formNameProp : formName;
  const messagetoPost = useSelector(hiddenMessage);
  const flat = useSelector(state => state?.flatInfo?.flatInfo);
  const cost = useSelector(mortgageCostSelector);
  const initialPayment = useSelector(mortgageInitialPaymentSelector);
  const term = useSelector(mortgageTermSelector);
  const policyForm = useSelector(policyFormSelector);
  const pathname = usePathname();
  const flatfavorites = useSelector(flatsLocalStorageSelector);
  const formStartedRef = useRef(false);
  const fieldHiddenRef = useRef(null);
  const {
    isMobile
  } = useViewport();
  const handleFormStart = () => {
    if (!formStartedRef.current) {
      pushDataLayer('form_success_start');
      formStartedRef.current = true;
    }
  };
  const schema = yup.object().shape({
    name: yup.string().required('Обязательное поле').matches(namePattern, 'Введите корректное имя'),
    phone: yup.string().required('Обязательное поле').matches(fullPhonePattern, 'Введите корректный номер'),
    comment: yup.string(),
    agreement: yup.bool(),
    checkbox_ads: yup.boolean()
  });
  const {
    control,
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: {
      name: '',
      phone: '',
      agreement: true,
      checkbox_ads: false
    }
  });
  const getClassName = () => {
    if (!favoriteInputForm) return cn(style.formCallTitle, classNameTitle);
    if (favoriteInputForm && pathname.includes(ROUTES.purchaseTerms.tradeIn)) return cn(style.formCallTitle, classNameTitle);
    return cn(style.formCallTitle, style.formCallTitle__bigForm);
  };
  const getCookieForm = name => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return '';
  };
  const handleChallengeHidden = useCallback(() => setCaptchaVisible(false), []);
  const submitData = async smartToken => {
    const data = {
      ...formData
    };
    data.checkbox_ads = String(data.checkbox_ads ?? false);
    if (fieldHiddenRef.current?.hasAttribute('value')) {
      data.field_hidden = fieldHiddenRef.current.value;
    }
    try {
      const tokenResponse = await axios.get(`${UNIVERSAL_ADMIN.slice(0, -9)}/api/v2/get_token`);
      const token = tokenResponse.data;
      data.sessionID = token;
    } catch (error) {
      console.error('Не удалось получить токен:', error);
    }
    if (data.sessionID === undefined) {
      dispatch(handleOpenModelError(true));
      setFormData(null);
      setCaptchaToken('');
      setCaptchaKey(crypto.randomUUID());
      setCaptchaVisible(false);
      return;
    }
    data.smartToken = smartToken;
    data.formName = favoriteInputForm ? 'favoritesForm' : formPropName;
    if (openTradeInForm || data.formName === 'commercialForm' || data.formName === 'mortgageForm' || formName === 'houseForm') {
      data.message = messagetoPost;
    }
    data.cm_data = COOKIE_SECURE_FORMA_29680 ? CookieStorage.get('cm_data') : getCookieForm('cm_data');
    data.comment = favoriteInputForm || openTradeInForm || formName === 'flatForm' || formName === 'reserveFlatForm' ? getValues('comment') : '';
    if (formName === 'mortgageForm') {
      data.price = cost;
      data.initialPayment = initialPayment;
      data.loanTerm = term;
      data.page = `${process.env.REACT_APP_DOMAIN}${pathname}`;
    }
    try {
      await api.sendForm(data);
      await api.logResponseGTM({
        event: 'event-to-gtm',
        eventCategory: 'Form',
        eventAction: 'Send',
        eventLabel: 'CallBack'
      });
      reset();
      openMessage();
      await timeOutPromise(() => closeMessage(), 3000);
      await timeOutPromise(() => {
        handleCloseFormModel?.();
        setFormData(null);
        setCaptchaToken('');
        setCaptchaKey(crypto.randomUUID());
      }, 2000);
    } catch (error_0) {
      console.log(error_0);
      dispatch(handleOpenModelError(true));
    }
  };

  //логирование данных
  const saveReserveForm = async () => {
    const data_0 = {
      name: getValues('name'),
      phone: getValues('phone'),
      formName: favoriteInputForm ? 'favoritesForm' : formPropName,
      comment: formName === 'flatForm' || formName === 'reserveFlatForm' || formName === 'tradeInForm' || favoriteInputForm ? getValues('comment') : '',
      message: formName === 'tradeInForm' || formName === 'mortgageForm' || formName === 'commercialForm' || formName === 'houseForm' ? messagetoPost : '',
      cm_data: (COOKIE_SECURE_FORMA_29680 ? CookieStorage.get('cm_data') : getCookieForm('cm_data')) ?? '',
      agreement: getValues('agreement'),
      checkbox_ads: String(getValues('checkbox_ads')) ?? 'false'
    };
    if (formName === 'mortgageForm') {
      data_0.price = cost;
      data_0.initialPayment = initialPayment;
      data_0.loanTerm = term;
      data_0.page = `${process.env.REACT_APP_DOMAIN}${pathname}`;
    }
    try {
      await api.logDataToServer(data_0);
    } catch (error_1) {
      console.log(error_1);
    }
  };
  useEffect(() => {
    if (flatfavorites && !pathname.includes(ROUTES.purchaseTerms.tradeIn)) {
      let apartmentsNumbersString = '';
      const localStorageArray = flatfavorites;
      localStorageArray.forEach(item => {
        if (item.apartmentNumber) {
          apartmentsNumbersString += item.apartmentNumber + ', ';
        } else {
          apartmentsNumbersString += item.number + ', ';
        }
      });
      apartmentsNumbersString = apartmentsNumbersString.slice(0, -2);
      if (apartmentsNumbersString !== '') {
        setValue('comment', `Меня интересуют квартиры: ${apartmentsNumbersString}`);
      }
    }
    if ((formName === 'flatForm' || formName === 'reserveFlatForm') && flat) {
      setValue('comment', `Меня интересует квартира № ${flat.number} в корпусе ${flat.bulk.number}, площадью ${flat.area} кв.м`);
    }
  }, [flatfavorites, pathname, formName, flat, setValue]);
  const onSubmit = data_1 => {
    setFormData(data_1);
    if (CAPTCHA_28788) {
      setCaptchaVisible(true);
      return;
    }

    // If captcha is disabled, submit immediately.
    submitData('');
  };
  useEffect(() => {
    // Если у нас есть и токен, и данные формы
    if (captchaToken && formData) {
      // 1. Запоминаем токен в локальную переменную
      const tokenForSubmission = captchaToken;

      // 2. СРАЗУ ЖЕ сбрасываем токен в состоянии.
      // Теперь он не сможет вызвать повторную отправку.
      setCaptchaToken('');

      // 3. Вызываем отправку с токеном, который мы сохранили.
      submitData(tokenForSubmission);
    }
  }, [captchaToken, formData]);
  return <div className={favoriteInputForm ? cn(style.formCallContainer, style.formCallContainer__bigForm) : style?.formCallContainer}>
      <div className={getClassName()}>
        {RESERVED_FLATS_31832 && formName === 'reserveFlatForm' && !isMobile ? <p>
            Оставьте свои <br />
            контакты для связи
          </p> : <p>Оставить заявку</p>}
      </div>
      {showMessage && <div className={style.formCallThanksText}>
          <p>Спасибо</p>
          <p>Мы получили ваш запрос и скоро свяжемся с вами</p>
        </div>}
      {!showMessage && <form name='form-call' onSubmit={handleSubmit(onSubmit)} className={style.formCallForm}>
          <div className={style.formCallInputBox}>
            <Controller name='name' control={control} render={({
          field
        }) => <InputName {...field} testid='input-name' placeholder='Имя' label='Имя' errors={Boolean(formState.errors.name)} errorLabel={formState.errors?.name?.message} onFocus={handleFormStart} />} />
          </div>
          <div className={style.formCallInputBox}>
            <Controller control={control} rules={{
          required: true,
          pattern: fullPhonePattern
        }} name='phone' render={({
          field: {
            ...field_0
          }
        }) => <InputPhone testid='input-phone' name='phone' field={field_0} placeholder='Телефон' label='Телефон' errors={Boolean(formState.errors.phone)} errorLabel={formState.errors?.phone?.message} onFocus={handleFormStart} />} />
          </div>
          {(favoriteInputForm || openTradeInForm || formName === 'reserveFlatForm' || COMMENT_MESSAGE_FORM_FORMA_32007 && formName === 'flatForm') && <div className={style.formCallInputBox}>
              <Textarea data-testid='input-comment' placeholder='Сообщение' register={register('comment')} label='Сообщение' errors={Boolean(formState.errors.comment)} errorLabel={formState.errors?.comment?.message} onFocus={handleFormStart} />
            </div>}
          <div className={style.formCallBtnBox}>
            <ButtonSend handleFunction={saveReserveForm} testId={testId} />
            <div className={style.formWrapper}>
              <SafeHydrate>
                {Boolean(policyForm.caption) && <SafeHtmlRenderer tag='div' className={style.formCallBtnText} content={policyForm.caption} />}
              </SafeHydrate>
              <SafeHydrate>
                {Boolean(policyForm.checkbox) && <div className={`${style.checkbox} ${style.formCallBtnText}`}>
                    <input id='checkbox_ads' type='checkbox' className={style.checkbox__input} data-testid='checkbox_ads-checkbox' {...register('checkbox_ads')} />
                    <SafeHtmlRenderer tag='label' htmlFor='checkbox_ads' content={policyForm.checkbox} />
                  </div>}
              </SafeHydrate>
            </div>
          </div>

          {/* {скрытое поле для отсечения ботов} */}
          <input ref={fieldHiddenRef} name='field_hidden' type='text' className={style.hiddenField} tabIndex={-1} autoComplete='off' />

          {/*SMARTCAPTCHA*/}
          {CAPTCHA_28788 && <InvisibleSmartCaptcha key={captchaKey} sitekey={process.env.NEXT_PUBLIC_SMART_CAPTCHA} onSuccess={token_0 => {
        setCaptchaToken(token_0);
        setCaptchaVisible(false);
      }} onChallengeHidden={handleChallengeHidden} visible={captchaVisible} hideShield />}
        </form>}
    </div>;
}
export default FormCall;